<template>
  <v-container fluid :class="$style['container']">
    <v-overlay :value="processing">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div :class="$style['container-header']">
      <h3><span>パスワード変更</span></h3>
    </div>
    <div :class="$style['container-content']">
      <v-content class="app-content">
        <div :class="$style['main-content']">
          <template>
            <MyForm :formKey="'base-form'" :entity="entity" :input="input" ref="form">
              <template v-for="(field, index) in fields">
                <FieldGenerator
                  v-model="input[field.name]"
                  :key="index"
                  :type="field.type"
                  :name="field.name"
                  :label="field.label"
                  :rules="field.rules"
                  :width="field.width"
                >
                </FieldGenerator>
              </template>
            </MyForm>
          </template>
        </div>
      </v-content>
    </div>
    <div :class="$style['container-btn']">
      <v-btn
        depressed
        color="black"
        dark
        @click="onchangePassword"
      >
        変更する
      </v-btn>
    </div>
  </v-container>
</template>

<script>
import MyForm from "@/components/form";
import FieldGenerator from "@/components/field/generator";

export default {
  components: {
    MyForm,
    FieldGenerator
  },
  data() {
    return {
      input: {},
      fields: [
        {
          label: "新しいパスワード",
          name: "password",
          width: "100%",
          type: "password",
          rules: "required|password|min:8|max:24",
        },
        {
          label: "確認",
          name: "password_confirmation",
          width: "100%",
          type: "password",
          rules: "required|confirmed:password"
        },
      ]
    };
  },
  computed: {
    entity() {
      return this.$store.getters[`customer/entity`];
    },
    processing() {
      return this.$store.getters[`customer/isProcessing`];
    },
    error() {
      return this.$store.getters[`customer/error`];
    },
    errorMessages() {
      return (
        this.$store.getters[`customer/errorMessages`] || []
      );
    },
  },
  methods: {
    onchangePassword() {
      if (!this.$refs.form) {
        return;
      }

      this.$refs.form.validate().then(success => {
        if (!success) {
          return;
        }

        this.$store
          .dispatch(`customer/changePassword`, {
            storedEntity: {
              password: this.input.password,
              password_confirmation: this.input.password_confirmation,
            }
          })
          .then(() => {
            this.setInput();

            this.$refs.form.resetErrors();
          })
          .catch(() => {
            if (this.$refs.form) {
              this.$refs.form.setErrors(this.errorMessages);
            }
          });
      });
    },
    setInput() {
      this.$store.commit(`customer/initialize`);

      this.input = {
        ...JSON.parse(
          JSON.stringify(
            this.$store.getters[`customer/initialEntity`]
          )
        )
      };
    }
  },
  created() {
    this.setInput();
  }
}
</script>

<style module lang="scss">
$base-app-header-height: 75px;
$base-header-height: 55px;

.container.container {
  height: calc(100% - #{$base-app-header-height});
  padding: 0;
  width: 700px;
  margin-left: auto;
  margin-right: auto;

  .container-header {
    height: $base-header-height !important;
    padding-top: 20px;
    text-align: center;
  }

  .container-content {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    overflow: hidden;
    padding-top: 20px;

    .main-content {
      padding: 8px;
      overflow-y: auto;
      overflow-x: hidden;
    }
  }

  .container-btn {
    text-align: center;

    button {
      width: 200px;
      height: 50px;
    }
  }
}
</style>